import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/zone';

import Form from "../../components/form/ui-semantic-form";
import FormElement from "../../components/form/ui-semantic-form-elements";

export class FormCustomer extends React.Component { 

	constructor(props) {
		super(props);
		this.state = {isLoading: true};
	}

	componentDidMount () {
		if(this.props.fetchModel != undefined)
		{
			this.props.fetchModel().then(function(response){
				this.setState({isLoading: false});
			}.bind(this));
		}
	}

	render () {
			return (
				<div id="data-customer">
				<Form 
					url="zone/create" 
					loading={this.state.isLoading}
					action={this.props.action} 
					onSuccess={this.onSuccess} 
					buttonSubmitTitle="Zapisz">
						<FormElement 
							type="text" 
							name="name" 
							title="Nazwa" 
							value={this.props.model.name} 
							validations="isLength:1"
						/>
						<FormElement 
							type="text" 
							name="street" 
							title="Ulica" 
							value={this.props.model.street} 
							validations="isLength:1" 
						/>
						<FormElement 
							type="text" 
							name="post_code" 
							title="Kod pocztowy" 
							value={this.props.model.post_code} 
							validations="isLength:1" 
						/>
						<FormElement 
							type="text" 
							name="city" 
							title="Miasto" 
							value={this.props.model.city} 
							validations="isLength:1" 
						/>
						<FormElement 
							type="text" 
							name="nip" 
							title="NIP" 
							value={this.props.model.nip} 
							validations="isLength:1" 
						/>
						<FormElement 
							type="text" 
							name="phone" 
							title="Telefon" 
							value={this.props.model.phone} 
							required 
						/>
				</Form>
				</div>
			);
	}
}

const mapStateToProps = (state) => ({
	model: state.customer.model,
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCustomer);


/** WEBPACK FOOTER **
 ** ./js/views/customer/Form.js
 **/